import { useStatsigClient } from '@statsig/react-bindings';
import { useMemo } from 'react';
import { resolveStatsigExperimentOrGate, transformExperimentToVariant, transformGateToVariant } from '../helpers';

const useVariant = (key, options) => {
  const statsigClient = useStatsigClient();
  const resolved = useMemo(() => resolveStatsigExperimentOrGate(statsigClient, key, options), [key, options, statsigClient]);
  return useMemo(() => resolved.type === 'feature-gate' ? transformGateToVariant(resolved) : transformExperimentToVariant(resolved), [resolved]);
};

export default useVariant;